import React from 'react'
import { History } from 'history'
import { InlineDataTable, HeaderRow, TableHeader, DataRow } from 'uiComponents/table'
import { NoResultsRow } from 'uiComponents/table/noResultsRow'
import { OptionsService, OptionItem } from 'products/options/optionsService'
import { OptionItemsRowCells } from './optionItemsRowCells'
import { MessageKind } from 'uiComponents/messages'
import { optionsLisColumnWidths } from './groupsList'
import { ButtonWrapper } from 'uiComponents/pageElements'
import { ActionButtonA } from 'uiComponents/buttons'
import { useTranslation } from 'translations'

interface OptionGroupsListPageProps {
    history: History
    accountSlug: string
    optionItems: OptionItem[]
    groupUuid: string
    optionsService: OptionsService
    loading: boolean
    reloadList: () => void
    replaceMessages: (id: string, status: MessageKind, text: string) => void
}

const columnWidths = optionsLisColumnWidths.slice(1)

export function OptionItemsList(props: OptionGroupsListPageProps) {
    const { t } = useTranslation()
    return (
        <>
            <InlineDataTable columnWidths={columnWidths} id="option-items-list">
                <HeaderRow>
                    <TableHeader>{t('products.options.itemsList.columns.name')}</TableHeader>
                    <TableHeader align="center">{t('products.options.itemsList.columns.priority')}</TableHeader>
                    <TableHeader>{t('products.options.itemsList.columns.price')}</TableHeader>
                    <TableHeader nonInteractive />
                </HeaderRow>
                {props.optionItems.length === 0 && <NoResultsRow text={t('products.options.itemsList.noResults')} />}
                {props.optionItems.map((item) => {
                    return (
                        <DataRow key={item.id} narrow>
                            <OptionItemsRowCells
                                optionItem={item}
                                groupUuid={props.groupUuid}
                                accountSlug={props.accountSlug}
                                history={props.history}
                                optionsService={props.optionsService}
                                replaceMessages={props.replaceMessages}
                                nested={false}
                                loading={props.loading}
                                reloadList={props.reloadList}
                            />
                        </DataRow>
                    )
                })}
                <ButtonWrapper>
                    <ActionButtonA
                        id="add-option-item"
                        size="large"
                        href={`/account/${props.accountSlug}/products/option_groups/option_item/${props.groupUuid}/new`}
                        style={{ marginTop: '2em' }}
                    >
                        {t('products.options.itemsList.addNew')}
                    </ActionButtonA>
                </ButtonWrapper>
            </InlineDataTable>
        </>
    )
}
